module.exports = __webpack_public_path__ + "static/sara-ff3623554b1ad6212030673712e09758.jpg";